import caseMethod from './case/case.js';
import commonMethod from './const/const.js';
import query from './config/queryconfig.js';
export default {
    caseMethod,
    commonMethod,
    query   
};


// WEBPACK FOOTER //
// ./src/method/index.js